<div role="main">
  <app-header></app-header>
  <div>
    <div class="alerts" *ngIf="notification?.queue?.length > 0">
      <div
        [ngClass]="{'alert alert-{{m.type}} alert-dismissable fade in pull-right' : (m.type != 'info'), 'alert alert-info alert-dismissable fade in pull-right': (m.type == 'info')}"
        *ngFor="let m of notification.queue; let i = index">
        <button type="button" class="close" (click)="closeNotification(i)" style="font-size: .9em;">
          x
        </button> &nbsp;
        <label>{{ m.title }}</label>
        <div>{{ m.body }}</div>
      </div>
    </div>

    <div class="col-md-6 offset-md-1 d-flex align-items-center">
      <span class="text-white-ref ref">Reference ID</span>
      <span class="ref-id-no ms-2">{{ service.referenceFileDetails.referenceId }}</span>
    </div>

      <form (ngSubmit)="next()">
        <!-- Navigation Links -->
        <div class="row link-container">
          <div class="col-md-auto offset-md-1 mt-3">
            <a class="btn btn-info custom-button" *ngIf="service.hasVisited('reference')" (click)="service.navigateTo('reference')"> Contact Information </a>
          </div>
          <div class="col-md-auto mt-3">
            <a class="btn btn-info-current custom-button"  *ngIf="true"> File Upload </a>
          </div>
          <div class="col-md-auto mt-3">
            <a class="btn btn-info custom-button" *ngIf="service.hasVisited('review-files')" (click)="service.navigateTo('review-files')"> Review & Submit Files </a>
          </div>
        </div>

        <!-- Error Message -->
        <div class="row" *ngIf="showError">
          <div class="col-md-6 offset-md-1 mt-5">
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
              <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
                (click)="showError = !showError"></button>
              <strong>Error </strong>{{ errorMsg }}
            </div>
          </div>
        </div>

        <!-- File Upload Section -->
        <div class="row align-items-center">
          <div class="col col-md-4 file-uploader-div fileuploadleft dropzone" fileDragDrop
            (filesChangeEmiter)="onFileChange($event)">
            <input type="file" name="file" id="file" (change)="onFileChange($event.target)"
              [accept]="acceptedFiles" multiple style="display:none">
            <div class="upload-content">
              <i class="fa-solid fa-cloud-arrow-up upload-arrow"></i>
              <span class="drag-text">Drag and drop your files here.</span>
              <span class="or-text">or</span>
              <label for="file" class="browse-btn">Browse Computer</label>
            </div>
          </div>
          <div class="col col-md-4" *ngIf="files.length > 0">
            <div class="d-flex justify-content-end mb-1" style="width: 120%;">
              <span class="text-white-sub">File Count: {{ files.length }}</span>
            </div>
            <div class="overflow-auto table-div" style="width: 120%;">
              <table class="table text-white" style="table-layout: fixed;">
                <thead class="bg-dark">
                  <tr>
                    <th scope="col" style="width: 65%;">Files</th>
                    <th scope="col" style="width: 35%;">Action</th>
                  </tr>
                </thead>
                <tbody>

                  <tr *ngFor="let item of files; let i=index;">
                    <td class="text-white-sub text-truncate" title="{{ item.fileName ?? item.name }}">{{ item.fileName ?? item.name }}</td>
                    <td> <button type="button" class="btn-enter" id="dashboardButton" (click)="removeFile(i)">Remove
                        File</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Buttons -->
        <div class="col-md-6 offset-md-1">
          <div class="button-group">
            <button type="button" class="btn-clear" id="backButton" (click)="back()">Back</button>
            <button type="button" class="btn-clear" id="cancelButton" (click)="cancel()">Cancel</button>
            <button type="submit" class="btn-enter" id="submitButton" [disabled]="isDisabled"
              [ngbTooltip]="(isDisabled) ? 'You must add a file to proceed.' : null" container="body"> Review & Submit Files </button>
          </div>
        </div>
      </form>

    <!-- Upload Instructions -->
    <div class="row uploadIns mt-3">
      <div class="col-md-6 offset-md-1">
        <span class="text-white">Upload Instructions:</span>
      </div>
      <div class="col-md-11 offset-md-1">
        <span class="text-white-sub">1. Click in the box to upload files or drag and drop files directly into the
          box.</span>
      </div>
      <div class="col-md-11 offset-md-1">
        <span class="text-white-sub">2. Ensure that you upload the requested information as directed in the request
          letter
          (i.e., separate files for each patient).</span>
      </div>
      <div class="col-md-11 offset-md-1">
        <span class="text-white-sub">3. Acceptable file types include: doc, docx, dcm, pdf, xls, xlsx, jpeg, jpg, bmp,
          png, tif, tiff, wav, mp3, eml, txt, and text/plain.</span>
      </div>
      <div class="col-md-11 offset-md-1">
        <span class="text-white-sub">4. If the file exceeds 1.5GB, please split the files into multiple files.</span>
      </div>
      <div class="col-md-11 offset-md-1">
        <span class="text-white-sub">5. Once all files have been added click on 'Review & Submit Files' button. Files
          are
          not submitted until you reach the final submission step.</span>
      </div>
    </div>

    <!-- Footer -->
    <app-footer [positionFixed]="false"></app-footer>
  </div>
</div>
